/**
 * @file 水机管理
 */

import request from '@/utils/request'

/**
 * @typedef {Object} WaterMachine 水机对象
 * @property {string|number} [id] 水机Id
 * @property {string|number} stationId 电站Id
 * @property {string} uuid UUID
 * @property {string} [devId] 设备ID（设备编码）
 * @property {string} waterMachineName 水机名称
 * @property {string} [factoryName] 厂家名称
 * @property {string} [productModel] 产品型号
 * @property {string|number} [parentEquipmentId] 关联设备ID
 * @property {number} [sort] 排序号
 */

/**
 * 修改水机
 * @param {WaterMachine} waterMachine
 */
export function updateWaterMachine(waterMachine) {
  return request({
    url: '/device/v3/water/machine',
    method: 'put',
    data: waterMachine
  })
}

/**
 * 新增水机
 * @param {WaterMachine} waterMachine
 */
export function addWaterMachine(waterMachine) {
  return request({
    url: '/device/v3/water/machine',
    method: 'post',
    data: waterMachine
  })
}

/**
 * 获取水机列表
 * @param {object} params
 * @param {string} params.stationId
 * @param {string} [params.waterMachineName]
 * @param {string} [params.productModel]
 * @param {string} [params.pageNum]
 * @param {string} [params.pageSize]
 * @returns
 */
export function getWaterMachineList(params) {
  return request({
    url: '/device/v3/water/machine/list',
    method: 'get',
    params: params
  })
}

/**
 * 批量删除水机
 * @param {string|number} ids 水机Id
 * @returns
 */
export function delWaterMachineList(ids) {
  if (Array.isArray(ids)) {
    ids = ids.join(',')
  }
  return request({
    url: `/device/v3/water/machine/${ids}`,
    method: 'delete',
  })
}

/**
 * 获取水机详细信息
 * @param {string|number} id 水机Id
 */
export function getWaterMachine(id) {
  return request({
    url: `/device/v3/water/machine/${id}`,
    method: 'get',
  })
}
